import { CDN_IMG_URL } from './url';

const getCdnIcon = (handle = '', extension = '.svg') =>
  `${CDN_IMG_URL}/icons/${handle}${extension}`;

export default getCdnIcon;
